const router = {}

// 篮球-联赛-赛程
const BasketballLeagueScheduleIndex = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleIndex" */ '@platfrom/basketball/league_schedule/index.vue'
  )
// 篮球-联赛-赛程详情
const BasketballLeagueScheduleDetailIndex = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleDetailIndex" */ '@platfrom/basketball/league_scheduleDetail/index.vue'
  )
const BasketballLeagueScheduleDetailPreMatch = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleDetailPreMatch" */ '@platfrom/basketball/league_scheduleDetail/childPage/preMatch.vue'
  )

const BasketballLeagueScheduleDetailHotspots = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleDetailLineup" */ '@platfrom/basketball/league_scheduleDetail/childPage/hotspots.vue'
  )

const BasketballLeagueScheduleDetailAnalysis = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleDetailAnalysis" */ '@platfrom/basketball/league_scheduleDetail/childPage/analysis.vue'
  )

const BasketballLeagueScheduleDetailStatistics = () =>
  import(
    /* webpackChunkName: "basketballLeagueScheduleDetailStatistics" */ '@platfrom/basketball/league_scheduleDetail/childPage/statistics.vue'
  )

// 篮球-联赛-球队
const BasketballLeagueTeamIndex = () =>
  import(
    /* webpackChunkName: "basketballLeagueTeamListIndex" */ '@platfrom/basketball/league_team/index.vue'
  )

const BasketballLeagueTeamRankIndex = () =>
  import(
    /* webpackChunkName: "basketballLeagueTeamRankIndex" */ '@platfrom/basketball/league_teamRank/index.vue'
  )

// 篮球-联赛-球队详情
const BasketballLeagueTeamDetailIndex = () =>
  import(
    /* webpackChunkName: "basketballLeagueTeamDetailIndex" */ '@platfrom/basketball/league_teamDetail/index.vue'
  )

const BasketballLeagueTeamDetailPlayerList = () =>
  import(
    /* webpackChunkName: "basketballLeagueTeamDetailPlayerList" */ '@platfrom/basketball/league_teamDetail/childPage/playerList.vue'
  )

const BasketballLeagueTeamDetailTeamData = () =>
  import(
    /* webpackChunkName: "basketballLeagueTeamDetailTeamData" */ '@platfrom/basketball/league_teamDetail/childPage/teamData.vue'
  )

const BasketballLeagueTeamDetailMatchRecord = () =>
  import(
    /* webpackChunkName: "basketballLeagueTeamDetailMatchRecord" */ '@platfrom/basketball/league_teamDetail/childPage/matchRecord.vue'
  )

const BasketballLeagueTeamDetailMatchSchedule = () =>
  import(
    /* webpackChunkName: "basketballLeagueTeamDetailMatchSchedule" */ '@platfrom/basketball/league_teamDetail/childPage/matchSchedule.vue'
  )

// 篮球-联赛-季后赛对阵
const BasketballLeaguePlayoffsVsMapIndex = () =>
  import(
    /* webpackChunkName: "basketballLeaguePlayoffsVsMapIndex" */ '@platfrom/basketball/league_playoffsVsMap/index.vue'
  )
// 篮球-联赛-数据
const BasketballLeagueRecordDetailIndex = () =>
  import(
    /* webpackChunkName: "basketballLeagueRecordDetailIndex" */ '@platfrom/basketball/league_record/index.vue'
  )

// 篮球-联赛-数据-数据概览
const BasketballLeagueRecordDetailDataOverview = () =>
  import(
    /* webpackChunkName: "basketballLeagueRecordDetailDataOverview" */ '@platfrom/basketball/league_record/childPage/dataOverview.vue'
  )
// 篮球-联赛-数据-球队数据
const BasketballLeagueRecordDetailTeamData = () =>
  import(
    /* webpackChunkName: "basketballLeagueRecordDetailTeamData" */ '@platfrom/basketball/league_record/childPage/teamData.vue'
  )
// 篮球-联赛-数据-球员数据
const BasketballLeagueRecordDetailPlayerData = () =>
  import(
    /* webpackChunkName: "basketballLeagueRecordDetailPlayerData" */ '@platfrom/basketball/league_record/childPage/playerData.vue'
  )

// 篮球-联赛-数据-阵容数据
const BasketballLeagueRecordDetailLineupData = () =>
  import(
    /* webpackChunkName: "basketballLeagueRecordDetailLineupData" */ '@platfrom/basketball/league_record/childPage/lineupData.vue'
  )

// 篮球-联赛-球员
const BasketballLeaguePlayerIndex = () =>
  import(
    /* webpackChunkName: "basketballLeaguePlayerIndex" */ '@platfrom/basketball/league_player/index.vue'
  )

// 篮球-联赛-球员详情
const BasketballLeaguePlayerDetailIndex = () =>
  import(
    /* webpackChunkName: "basketballLeaguePlayerDetailIndex" */ '@platfrom/basketball/league_playerDetail/index.vue'
  )

const BasketballLeaguePlayerDetailSeasonData = () =>
  import(
    /* webpackChunkName: "basketballLeaguePlayerDetailSeasonData" */ '@platfrom/basketball/league_playerDetail/childPage/seasonData.vue'
  )

const BasketballLeaguePlayerDetailCareerData = () =>
  import(
    /* webpackChunkName: "basketballLeaguePlayerDetailCareerData" */ '@platfrom/basketball/league_playerDetail/childPage/careerData.vue'
  )

const BasketballLeaguePlayerDetailMatchRecord = () =>
  import(
    /* webpackChunkName: "basketballLeaguePlayerDetailMatchRecord" */ '@platfrom/basketball/league_playerDetail/childPage/matchRecord.vue'
  )

// 篮球-联赛-场馆
const BasketballLeagueSportsHallIndex = () =>
  import(
    /* webpackChunkName: "basketballLeagueSportsHallIndex" */ '@platfrom/basketball/league_sportsHall/index.vue'
  )

// 篮球-联赛-播出单
const BasketballLeagueBroadcastListIndex = () =>
  import(
    /* webpackChunkName: "commonPageBroadcastListIndex" */ '@platfrom/commonPage/broadcastList/index.vue'
  )

// 篮球-联赛-数据包装
const BasketballLeagueDataPackagListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageDataPackagListIndex" */ '@platfrom/commonPage/dataPackagList/index.vue'
  )

// 篮球-联赛-节目单
const BasketballLeagueProgramListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageProgramListIndex" */ '@platfrom/commonPage/programList/index.vue'
  )

router.BasketballLeagueScheduleIndex = BasketballLeagueScheduleIndex
router.BasketballLeagueScheduleDetailIndex = BasketballLeagueScheduleDetailIndex
router.BasketballLeagueTeamRankIndex = BasketballLeagueTeamRankIndex
router.BasketballLeagueScheduleDetailPreMatch =
  BasketballLeagueScheduleDetailPreMatch
router.BasketballLeagueScheduleDetailHotspots =
  BasketballLeagueScheduleDetailHotspots
router.BasketballLeagueScheduleDetailAnalysis =
  BasketballLeagueScheduleDetailAnalysis
router.BasketballLeagueScheduleDetailStatistics =
  BasketballLeagueScheduleDetailStatistics
router.BasketballLeagueTeamIndex = BasketballLeagueTeamIndex
router.BasketballLeagueTeamDetailIndex = BasketballLeagueTeamDetailIndex
router.BasketballLeagueTeamDetailTeamData = BasketballLeagueTeamDetailTeamData
router.BasketballLeagueTeamDetailPlayerList =
  BasketballLeagueTeamDetailPlayerList
router.BasketballLeagueTeamDetailMatchRecord =
  BasketballLeagueTeamDetailMatchRecord
router.BasketballLeagueTeamDetailMatchSchedule =
  BasketballLeagueTeamDetailMatchSchedule
router.BasketballLeaguePlayoffsVsMapIndex = BasketballLeaguePlayoffsVsMapIndex
router.BasketballLeagueRecordDetailIndex = BasketballLeagueRecordDetailIndex
router.BasketballLeagueRecordDetailDataOverview =
  BasketballLeagueRecordDetailDataOverview
router.BasketballLeagueRecordDetailTeamData =
  BasketballLeagueRecordDetailTeamData
router.BasketballLeagueRecordDetailPlayerData =
  BasketballLeagueRecordDetailPlayerData
router.BasketballLeagueRecordDetailLineupData =
  BasketballLeagueRecordDetailLineupData
router.BasketballLeaguePlayerIndex = BasketballLeaguePlayerIndex
router.BasketballLeaguePlayerDetailIndex = BasketballLeaguePlayerDetailIndex
router.BasketballLeaguePlayerDetailSeasonData =
  BasketballLeaguePlayerDetailSeasonData
router.BasketballLeaguePlayerDetailCareerData =
  BasketballLeaguePlayerDetailCareerData
router.BasketballLeaguePlayerDetailMatchRecord =
  BasketballLeaguePlayerDetailMatchRecord
router.BasketballLeagueSportsHallIndex = BasketballLeagueSportsHallIndex
router.BasketballLeagueBroadcastListIndex = BasketballLeagueBroadcastListIndex
router.BasketballLeagueDataPackagListIndex = BasketballLeagueDataPackagListIndex
router.BasketballLeagueProgramListIndex = BasketballLeagueProgramListIndex

export default router
